import React, { useState } from 'react';
import SafeIcon from '../../SafeIcon';
import { FiMenu, FiTrash2 } from 'react-icons/fi';

export const WidgetWrapper = ({ el, children, onContextMenu, onDelete }) => {
  const [hovered, setHovered] = useState(false);
  const typeLabel = el.type === 'contact-form' ? 'Contact Form' : el.type === 'artist' ? 'Music/Artist' : el.type.charAt(0).toUpperCase() + el.type.slice(1);
  
  const handleDragStart = (e) => {
    e.stopPropagation();
    e.dataTransfer.setData('reorderId', String(el.id));
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="relative w-full group/widget" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onContextMenu={onContextMenu}>
      {hovered && <div className="absolute inset-0 pointer-events-none z-[40] rounded-lg ring-2 ring-teal-400" />}
      {hovered && (
        <div className="absolute -top-[24px] left-0 z-[70] flex items-center space-x-0.5 pointer-events-auto">
          <div draggable onDragStart={handleDragStart} className="bg-teal-500 text-white text-[9px] font-black uppercase tracking-widest px-2 py-1 rounded-t-md flex items-center space-x-1 cursor-grab active:cursor-grabbing shadow-sm select-none">
            <SafeIcon icon={FiMenu} className="w-3 h-3 opacity-80" />
            <span>{typeLabel}</span>
          </div>
          <button onClick={(e) => { e.stopPropagation(); onDelete(); }} className="bg-red-500 text-white text-[9px] font-black px-2 py-1 rounded-t-md hover:bg-red-600 transition-colors flex items-center shadow-sm">
            <SafeIcon icon={FiTrash2} className="w-3 h-3" />
          </button>
        </div>
      )}
      {children}
    </div>
  );
};